module.exports = __webpack_public_path__ + "media/精工工艺--公共楼道.965cc798.mp4";